<script>
    import {push} from 'svelte-spa-router';
	import Header from './Header.svelte';
    export let params = {}
	import Modal, { bind } from 'svelte-simple-modal';
	import PopupMebot from './PopupMebot.svelte';
	import { writable } from 'svelte/store';
	//import { onMount } from 'svelte';

	import { loader } from './loader';
	let loading = writable(true);

	const modal = writable(null);

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let dash_token = params.t
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
	}

    let mebot_id = params.id
    mebot_id = getCookie('m_id');

    let mebot_chats = [];
	let mebot_chats_tmp = [];
    let mebot_attr = [];
    let actions = [];

    let mebot_url;
    mebot_url = getCookie('mebot_img_url');

    let thread_id = 0;

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function set_section(name) {
        setCookie("section", name, 1)
    }

	let result = null
    let mebot_img_url = null;
    let mebot_badges = '';
    let mebot = [];
	let show_close = true;
	let timeout_id;
	let page_size = 28;

	let fetching = false;
    loading.update(n => fetching);

	async function getMebot(mebot_id = 0) {

		const stat_type = 1;
		let res = await fetch('https://api.forever.today/?method=get_mebot_stat', {
			method: 'POST',
			body: JSON.stringify({
				dash_token,
                mebot_id,
                stat_type
            })
		})

        let json = await res.json()
        result = json

        mebot = json.data.mebot;
		if (mebot.badges.length > 0) {
			mebot_badges = mebot.badges[0].em
		}

		mebot_img_url = mebot.mebot_img_url;
	}

    //getMebot(mebot_id)

    async function sendChat(offset = 0, msg = '') {

        const allSpacesRemoved = msg.replaceAll(' ', '');
        if (allSpacesRemoved == '') {
            return;
        }

		fetching = true;
		loading.update(n => fetching);

        mebot_chats_tmp = [];
        mebot_chats_tmp.push({img: '🎧', msg: msg, time_ago: 1, is_system: 0});
		mebot_chats = mebot_chats.concat(mebot_chats_tmp);

		const res = await fetch(
			"https://api.forever.today/?method=send_chat",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
                    thread_id,
                    mebot_id,
                    msg,
					offset
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.chats;

		mebot_attr = json.data.attr;
		mebot_chats_tmp = [];

		for (const runner of runners) {
			mebot_chats_tmp.push({
				img: runner.mebot_img_url,
				msg: runner.msg,
				time_ago: runner.time_ago,
                is_system: runner.is_system
			});
		}

		if (offset == 0) {
			mebot_chats = mebot_chats_tmp;
		} else {
			//append
			mebot_chats = mebot_chats.concat(mebot_chats_tmp);
		}
		page_size = json.data.page_size;

		fetching = false;
		loading.update(n => fetching);
	}

    async function getChatActions() {

        let tmp_actions = [];

        const res = await fetch(
			"https://api.forever.today/?method=get_chat_actions",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
                    mebot_id
				}),
			}
		);

        const json = await res.json();
		let runners = json.data.actions;

        for (const runner of runners) {
			tmp_actions.push(runner)
		}
        actions = tmp_actions;

        //console.log(actions)
    }

    async function getChats(offset = 0) {

		fetching = true;
		loading.update(n => fetching);

		const res = await fetch(
			"https://api.forever.today/?method=get_chat_thread",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
                    thread_id,
                    mebot_id,
					offset
				}),
			}
		);

        const json = await res.json();
        let runners = json.data.chats;

		mebot_attr = json.data.attr;
		mebot_chats_tmp = [];

		for (const runner of runners) {
			mebot_chats_tmp.push({
				img: runner.mebot_img_url,
				msg: runner.msg,
				time_ago: runner.time_ago,
                is_system: runner.is_system,
                msg_id: runner.msg_id,
			});
		}

		if (offset == 0) {
			mebot_chats = mebot_chats_tmp;
		} else {
			//append
			mebot_chats = mebot_chats.concat(mebot_chats_tmp);
		}
		page_size = json.data.page_size;
        thread_id = json.data.thread_id;
        console.log('thread id: ' + thread_id);

		fetching = false;
		loading.update(n => fetching);

        //if (mebot_chats.length > 2 ) {
            await sleep(100);
            let chats = document.querySelector('.main1')
            //console.log(chats.scrollHeight)
            //chats.scrollTop = 2000;
            chats.scrollTo({
                top: 2000,
                left: 0,
                behavior: "smooth",
            });
        //}
	}

    /*
    async function getChats(offset = 0) {
        mebot_chats.push({img: '🎧', msg: 'Ask me anything :)', time_ago: 1, is_system: 1});
    }*/

    getChatActions();
    getChats(0)

	function sleep(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms ?? 200));
	}

    function displayArtifactBlurb(blurb) {

		displayMebotMessage(`
		<center>
			<br>

			` + blurb + `

            <br>
		</center>`, 30000, 'Ok');
    }

	function displayMebotMessage(msg, delay, action_button = false, action = null) {
		let is_show_close = true
		clearTimeout(timeout_id);
		modal.set(null);
		show_close = is_show_close
		if (action != null) {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button, on_action: action }));
		} else {
			modal.set(bind(PopupMebot, { p_message: msg, closeButton: true, action_button}));
		}
		timeout_id = setTimeout(function(){ modal.set(null); }, delay);
	}

    function numberWithCommas(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	const getX = () => {
        let myDiv = document.querySelector('.main1')
        myDiv.scrollTop = myDiv.scrollHeight;
        return myDiv.scrollHeight - myDiv.scrollTop;
    }

	let x = 800 // the value returned by getX() function
    let contentLength = 0; // number of items that load on the page initially

    const loadOnScroll = (elem) => {
		//console.log('scrollTop: ' + elem.scrollTop + ' scrollHeight: ' + elem.scrollHeight);
		if (elem.scrollTop >= (elem.scrollHeight - x) ) {

			if (fetching == false) {
				contentLength += page_size;
				//getBattleStage(contentLength);
				console.log(contentLength)
			}
		}
	}

	//onMount(() => {
	//	console.log ( getX() );
	//});

    let value = '';
	let onChange = () => {};

	let onCancel = () => {};
	let onOkay = () => { 
        console.log (value)
        sendChat(1, value)
        value = '';
    };
	
	function _onCancel() {
		onCancel();
		close();
	}
	
	function _onOkay() {
		onOkay(value);
		close();
	}

    function displayMenu(id) {
        console.log('id: ' + id);
    }

    function keyPressed(key) {

        //e.which === 13 && _onOkay()
        //console.log(key)
        if (key == 13) {
            _onOkay()
        }
        if (key == 191 && value.length == 0) {

            document.getElementById("chat_input").attributes["type"].value = "search";

            //var mycars = ['/Available items', '/Collect items', '/Help'];
            var list = document.getElementById('mebot_actions');

            actions.forEach(function(item){
                var option = document.createElement('option');
                option.value = item;
                option.id = item;
                //make sure it doesn't exist yet
                //console.log( document.getElementById(item) )
                if ( document.getElementById(item) == null ) {
                    list.appendChild(option);
                }
            });

            //check if this was first letter in input box
            //modify input box
            //add commands
            //console.log(Array.from(value)[0])
            //console.log('key: ' + key);
            //console.log('first key: ' + value.charAt(0));
        }
    }

	$: onChange(value)
</script>

<Header
    header_mebot_id = { mebot_id }
    header_dash_token = { dash_token }
/>

<center>

    <div class="main1" on:scroll="{ () => loadOnScroll(document.querySelector('.main1')) }">
    <center>

<br>
<center>

<table width=300px cellspacing=0 border=0>

        {#each mebot_chats as mebot, i}

        {#if mebot.is_system == 1}
        <tr>
            <td width=20px valign=bottom>
                <img src="{mebot_url}" width=30px height=30px alt="mebot" style="padding-bottom: 8px;">
            </td>
            <td>
<!--            <span style="position: relative;">
                <span class="mebot__badge"> <img src="{mebot_url}" width=30px height=30px alt="mebot"> </span>-->

            <table border=0 width=260px on:click={ displayMenu( mebot.msg_id ) }>
            <tr><td>
                <span class="text-glow-green chat_bubble">
                    {@html mebot.msg }
                </span>
            </td></tr>
            </table>

<!--            </span>-->
        </td></tr>
        {:else}
        <tr><td align=right colspan=2>
            <table border=0 width=200px><tr><td align=right>
                <span class="text-glow-green chat_bubble chat_bubble_mine">
                    {@html mebot.msg }
                </span>
            </td></tr></table>
        </td></tr>
        {/if}
        {/each}

<tr><td align=right colspan=2>

<div class="loader" use:loader={loading}>
</div>

<br>
</td></tr>

<tr><td align=right width=280px colspan=2>

<table width=280px border=0>
    <tr>
        <td width=230px>
            <input id="chat_input" class="chat_input" type="text" list="mebot_actions"
            bind:value
            on:keydown={e => keyPressed(e.which)} /> 

            <datalist id="mebot_actions">
            <!--            
                <option value="/Available items">
                <option value="/Collect items">
                <option value="/Help">
                <option value="/Attack">
             -->
            </datalist>
        </td>
        <td width=50px>
            <div class="buttons">
                <!--<button on:click={_onCancel}>
                Clear
                </button>
                &nbsp;-->
                <button class="chat_button" on:click={_onOkay}>
                    &nbsp; ▶ &nbsp;
                </button> 
                <!---&nbsp;&nbsp;-->
            </div>
        </td>
    </tr>
</table>

</td></tr>

    </table>

</center>
    <br><br><br><br><br><br>
    <br><br><br><br><br><br>
    <br><br><br><br><br><br>

</center>

</div>

</center>

<Modal
        show={$modal}
		classWindowWrap="relative m-2 max-h-full"
        styleBg={{ backgroundColor: 'rgba(0, 0, 0, 0.2); opacity: .99;' }}
		styleWindow={{
			boxShadow: '0 20px 50px 0 rgba(0, 0, 0, 1)',
			backgroundColor: 'rgb(5, 20, 32, .96	); opacity: 1;'  }}
        closeButton={show_close}
		closeOnOuterClick={false}
		>
</Modal>

<style>
      
.mebot__badge {
    position: absolute; /* Position the badge within the relatively positioned button */
    top: -35px;
    left: 0px;
}

input {
    width: 100%;
}

.buttons {
    display: flex;  
    justify-content: space-between;
}

.chat_button {
    color: white;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.501);
    background-color: #016c8a;
    white-space: nowrap;
    height: 38px;
}

.text-glow-green {
	text-shadow: 0 0 10px rgb(0, 255, 255), 0 0 32px rgba(0, 117, 117, 0.819);
	font-family: arial;
	color: #1bffe8ee;
}

.chat_input {
    border-radius: 10px;
    border: 1px solid #1bffe880;
    color: white;
    background-color: rgba(0, 70, 114, 0.39);
    width: 230px;
    height: 38px;
}

.chat_bubble {
    background-color: rgba(0, 24, 39, 0.6);
    border-radius: 10px;
    border: 1px solid rgb(83, 83, 83);
    box-shadow: 0 1px 10px rgba(50, 255, 241, 0.504);
    padding: 10px;
    margin-bottom: 6px;
    display: flex;
    flex-grow: 0;
    flex-shrink: 0;
}

.chat_bubble_mine {
    background-color: rgba(0, 70, 114, 0.6);
    box-shadow: 0 1px 10px rgba(50, 187, 255, 0.504);
    justify-content: flex-end;
}

.main1 {
    border-radius: 20px;
    background-color: transparent;
    background-color: transparent;
    height: 700px;
    width: 370px;
    overflow-x: hidden;
/*    overflow-y: scroll;  */
    overflow-y: auto;
    text-align: left;
    padding: 0px;
    overscroll-behavior: auto;
    border: none;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.main1::-webkit-scrollbar {
  display: none;
}

</style>